var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"addImage",staticClass:"contract-image"},[(!_vm.houseDetailImage)?_c('div',{ref:"capture",staticClass:"image-content"},[(_vm.houseId)?_c('share-house',{attrs:{"houseCid":_vm.houseId}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-031c22e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/mgtCategory/bookingMgt/bizContract/html2image.vue
// module id = null
// module chunks = 